import React, { useEffect, useState } from 'react';
import { Building2, Pencil, Plus, Trash2 } from 'lucide-react';
import api, { getApiErrorMessage } from '../../services/api';
import { FeedbackBanner } from '../../components/ui/PageLayout';

export default function UnidadesPanel() {
  const [unidades, setUnidades] = useState([]);
  const [nome, setNome] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const [formOpen, setFormOpen] = useState(false);

  const load = async () => {
    try { const { data } = await api.get('/unidades'); setUnidades(data); }
    catch (error) { setFeedback({ type: 'error', message: getApiErrorMessage(error, 'Não foi possível carregar as unidades.') }); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const save = async (event) => {
    event.preventDefault();
    if (!nome.trim() || saving) return;
    setSaving(true); setFeedback(null);
    try {
      if (editingId) await api.put(`/unidades/${editingId}`, { nome: nome.trim() });
      else await api.post('/unidades', { nome: nome.trim() });
      setNome(''); setEditingId(null); setFormOpen(false);
      await load();
      setFeedback({ type: 'success', message: 'Unidade salva com sucesso.' });
    } catch (error) { setFeedback({ type: 'error', message: getApiErrorMessage(error, 'Não foi possível salvar a unidade.') }); }
    finally { setSaving(false); }
  };
  const remove = async (item) => {
    if (!window.confirm(`Excluir ${item.nome}?`)) return;
    setSaving(true); setFeedback(null);
    try {
      await api.delete(`/unidades/${item.id}`);
      if (editingId === item.id) { setEditingId(null); setNome(''); setFormOpen(false); }
      await load();
    } catch (error) { setFeedback({ type: 'error', message: getApiErrorMessage(error, 'Não foi possível excluir a unidade.') }); }
    finally { setSaving(false); }
  };
  return <section className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
    <div className="mb-5 flex items-start gap-3">
      <span className="rounded-xl bg-teal-50 p-3 text-teal-700"><Building2 size={24} /></span>
      <div className="flex-1"><h2 className="text-lg font-bold text-slate-800">Unidades</h2><p className="mt-1 text-sm text-slate-500">Clique em + e crie uma unidade com o nome que desejar.</p></div>
      <button type="button" aria-label="Criar unidade" title="Criar unidade" disabled={saving || loading} onClick={() => { setNome(''); setEditingId(null); setFormOpen(true); setFeedback(null); }} className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-condo-dark text-white disabled:opacity-50"><Plus size={22} /></button>
    </div>
    <FeedbackBanner type={feedback?.type} message={feedback?.message} onClose={() => setFeedback(null)} />
    {formOpen && <form onSubmit={save} className="mb-5 flex flex-wrap items-end gap-3">
      <label className="min-w-48 flex-1"><span className="mb-2 block text-sm font-semibold text-slate-700">Nome da unidade</span><input autoFocus required maxLength={80} value={nome} onChange={(event) => setNome(event.target.value)} placeholder="Digite o nome que deseja criar" className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:ring-2 focus:ring-condo-teal" /></label>
      <button type="submit" disabled={saving || loading} className="inline-flex items-center gap-2 rounded-xl bg-condo-dark px-5 py-3 text-sm font-bold text-white disabled:opacity-50">{saving ? 'Salvando...' : editingId ? 'Salvar alteração' : 'Criar unidade'}</button>
      <button type="button" disabled={saving} onClick={() => { setEditingId(null); setNome(''); setFormOpen(false); }} className="rounded-xl border px-4 py-3 text-sm text-slate-600">Cancelar</button>
    </form>}
    {loading ? <p className="text-sm text-slate-500">Carregando unidades...</p> : !unidades.length ? <p className="text-sm text-slate-500">Nenhuma unidade criada. Use o botão + para começar.</p> : <ul className="divide-y divide-slate-100">{unidades.map((item) => <li key={item.id} className="flex items-center justify-between gap-3 py-3">
      <div className="flex items-center gap-3"><Building2 size={20} className="shrink-0 text-teal-700" /><div><p className="font-semibold text-slate-800">{item.nome}</p><p className="text-xs text-slate-500">{item.total_moradores} morador(es) cadastrado(s)</p></div></div>
      <div className="flex gap-2"><button type="button" disabled={saving} title={`Editar ${item.nome}`} onClick={() => { setNome(item.nome); setEditingId(item.id); setFormOpen(true); }} className="rounded-lg p-2 text-slate-600 hover:bg-slate-100"><Pencil size={17} /></button><button type="button" disabled={saving} title={`Excluir ${item.nome}`} onClick={() => remove(item)} className="rounded-lg p-2 text-red-600 hover:bg-red-50"><Trash2 size={17} /></button></div>
    </li>)}</ul>}
  </section>;
}
